import React from 'react';
import { ReactComponent as DownloadIcon } from "assets/img/svg/downloadIcon.svg";
import { exportToExcel } from 'views/pages/manage/unAssigned/collectPayment/selectCharges/downloadChargesData/downloadExcel/exportToExcel';
import { getSubmissionStatusExcelDetails } from './utils';





const DownloadSubmissionStatusExcel = ({
    processId,
    fileName,
    status,
    transferType
}) => {

    const headers = [
    { label: 'Out Business Area', key: 'outBusinessArea' },
    { label: 'PSID', key: 'psid' },
    { label: 'Out Application Id', key: 'outApplicationId' },
    { label: 'Out Course ID', key: 'outCourseId' },
    { label: 'Trin Business Area', key: 'inBusinessArea' },
    { label: 'Trin Cashier Office', key: 'inCashierOffice' },
    { label: 'Trin Application Id', key: 'inApplicationId' },
    { label: 'Trin Course ID', key: 'inCourseId' },
    // { label: 'Term', key: 'term' },  //---todo uncomment in next deployment----
    { label: 'Transfer Amount', key: 'amount' },
    { label: 'Status', key: 'status'},
    { label: 'Failure Reason', key: 'response'},
]

    const downloadFile = async () => {
        try {
            const res = await getSubmissionStatusExcelDetails(processId);
            exportToExcel(res, headers, fileName)
        }
        catch (err) {
            console.log(err)
        }
    }



    return (
        <div>
            {status !== 'IN_PROGRESS' && <DownloadIcon className=' ml-2 cursor' onClick={() => downloadFile()} />}
        </div>
    );

}

export default DownloadSubmissionStatusExcel;